import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import PromoPopup from "./components/PromoPopup";
import Home from "./pages/Home";
import Wines from "./pages/Wines";
import Process from "./pages/Process";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Weddings from "./pages/Weddings";
import OrderNow from "./pages/OrderNow";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancelled from "./pages/PaymentCancelled";
import AdminLogin from "./pages/AdminLogin";
import AdminResetPassword from "./pages/AdminResetPassword";
import SecureAdminDashboard from "./pages/SecureAdminDashboard";
import CampaignApp from "./pages/ff/CampaignApp";
import WineOfTheYear from "./pages/WineOfTheYear";
import WotyGallery from "./pages/WotyGallery";
import HolidayGifting from "./pages/HolidayGifting";
import WotyArtistProfile from "./pages/WotyArtistProfile";
import { Toaster } from "./components/ui/toaster";
import { captureUtm, attachMainSiteTracker } from "./lib/tracking";
import "@/App.css";

// Detect the campaign subdomain at runtime.
// - corp.thelokal.ca (Corporate & Custom Wine, current) — mounts at root
// - ff.thelokal.ca (legacy Family & Friends) — still routes to the same shell so old links keep working
const isCampaignHost =
  typeof window !== "undefined" &&
  /^(corp|ff)\./i.test(window.location.hostname);

function App() {
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const handleBookCall = () => setBookingModalOpen(true);

  useEffect(() => {
    if (isCampaignHost) return undefined;
    captureUtm();
    return attachMainSiteTracker();
  }, []);

  // Campaign subdomain → dedicated app, no main navbar/footer/popup
  if (isCampaignHost) {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<CampaignApp basePath="" />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Campaign routes under /corp/* (canonical) and /ff/* (legacy alias) */}
          <Route path="/corp/*" element={<CampaignApp basePath="/corp" />} />
          <Route path="/ff/*" element={<CampaignApp basePath="/ff" />} />

          {/* Main site routes — wrapped with navbar + footer + popup */}
          <Route
            path="/*"
            element={
              <>
                <Navbar onBookCall={handleBookCall} />
                <Routes>
                  <Route path="/" element={<Home onBookCall={handleBookCall} />} />
                  <Route path="/wines" element={<Wines onBookCall={handleBookCall} />} />
                  <Route path="/process" element={<Process onBookCall={handleBookCall} />} />
                  <Route path="/order" element={<OrderNow />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                  <Route path="/payment-cancelled" element={<PaymentCancelled />} />
                  <Route path="/weddings" element={<Weddings />} />
                  <Route path="/wine-of-the-year" element={<WotyGallery />} />
                  <Route path="/holiday-gifting" element={<HolidayGifting />} />
                  <Route path="/wine-of-the-year/gallery" element={<Navigate to="/wine-of-the-year" replace />} />
                  <Route path="/wine-of-the-year/artist/:slug" element={<WotyArtistProfile />} />
                  <Route path="/wine-of-the-year/:slug" element={<WotyArtistProfile />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin/reset" element={<AdminResetPassword />} />
                  <Route path="/admin/dashboard" element={<SecureAdminDashboard />} />
                </Routes>
                <Footer />
                <BookingModal open={bookingModalOpen} onOpenChange={setBookingModalOpen} />
                <PromoPopup onBookCall={handleBookCall} />
              </>
            }
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
